const NumberFormatter = {
    format: (input: number | string, decimalPlaces?: number): string =>
        Number(input).toLocaleString('de-DE', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        })
};

export default NumberFormatter;
